'use client';

import { useEffect, useState } from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';

import { ButtonExperiment } from '../ButtonExperiment';
import { ExtendedLink } from '../ExtendedLink';

import styles from './styles.module.css';

import { GUEST_LIKES_TOAST_TIMEOUT } from '@/modules/guestLikes/constants';
import { type GuestLikeToastState } from '@/modules/guestLikes/types';

export function GuestLikesToast({
  description,
  illustration,
  title,
  cta,
  dismiss,
}: GuestLikeToastState & { dismiss: () => void }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const isPaused = isHovered || isFocused;

  useEffect(() => {
    if (isPaused) {
      return;
    }
    const timer = setTimeout(dismiss, GUEST_LIKES_TOAST_TIMEOUT);
    return () => clearTimeout(timer);
  }, [isPaused]);

  return (
    <div
      className={styles.guestLikeToast}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      {illustration}
      <div className={styles.guestLikeToastContent}>
        <Caption colour="base" variant="lg-bold">
          {title}
        </Caption>
        <Caption colour="base" variant="lg-regular">
          {description}
        </Caption>
      </div>
      {cta && (
        <ExtendedLink href={cta.href} className={styles.ctaLink}>
          <ButtonExperiment
            as="span"
            legacyClassName={styles.ctaPadding}
            size="small"
          >
            {cta.title}
          </ButtonExperiment>
        </ExtendedLink>
      )}
    </div>
  );
}
